import React, { useContext, useEffect, useMemo, useState } from "react";

import { CompanyService } from "../services";

const CompaniesContext = React.createContext();

export function useCompaniesContext() {
  return useContext(CompaniesContext);
}

export function CompaniesProvider({ children }) {
  const [allCompanies, setAllCompanies] = useState([]);

  useEffect(() => {
    let isActive = true;
    CompanyService.get().then((data) => isActive && setAllCompanies(data));
    return () => {
      isActive = false;
    };
  }, []);

  const companies = useMemo(() => allCompanies.filter((company) => !company.isTemporaryOwner), [allCompanies]);
  const temporaryOwners = useMemo(() => allCompanies.filter((company) => company.isTemporaryOwner), [allCompanies]);

  const updateCompany = (company) =>
    CompanyService.update(company).then((updated) => {
      setAllCompanies((prev) => prev.map((c) => (c.id === updated.id ? updated : c)));
      return updated;
    });

  const addCompany = (company) =>
    CompanyService.add(company).then((newCompany) => {
      setAllCompanies((oldState) => [...oldState, newCompany]);
    });

  const deleteCompany = (id) =>
    CompanyService.remove(id).then(() => setAllCompanies((prev) => prev.filter((company) => company.id !== id)));

  return (
    <CompaniesContext.Provider value={{ addCompany, updateCompany, deleteCompany, companies, temporaryOwners }}>
      {children}
    </CompaniesContext.Provider>
  );
}
